export { default } from './ChartPie'
